import { render, staticRenderFns } from "./FormBuilderList.vue?vue&type=template&id=0caf37f0&scoped=true&lang=pug&"
import script from "./FormBuilderList.vue?vue&type=script&lang=js&"
export * from "./FormBuilderList.vue?vue&type=script&lang=js&"
import style0 from "./FormBuilderList.vue?vue&type=style&index=0&id=0caf37f0&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0caf37f0",
  null
  
)

/* custom blocks */
import block0 from "./FormBuilderList.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports